import {HttpClient} from "../../service/httpClient/HttpClient";


export class GeneralService {

    constructor() {
        this.httpClient = new HttpClient()
    }

    getAvailableCashList(page, size) {
        return new Promise((resolve, reject) => {
            this.httpClient.get(
                `total-owners/funds`,
                {
                    page,
                    size
                }
            ).then(resolve).catch(reject)
        })
    }
}